export default __webpack_public_path__ + "static/media/hand.ee3fd5b8.jpg";